import script from "./Footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Footer.vue?vue&type=script&lang=ts&setup=true"

import "./Footer.vue?vue&type=style&index=0&id=7f2c975a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f2c975a"]])

export default __exports__